import { useExperience } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Button, Loading, Text } from '@cascade/ui-library';
import classes from './ExperienceStep.module.scss';
import { ExperienceHeading } from './experience-heading/index.ts';
import { ExperienceSection } from './experience-section/index.ts';
import { GenerationFailed } from './generation-failed/index.ts';

export const ExperienceStep = () => {
  const { translate, translateError } = useI18n();
  const {
    currentStep,
    isLoadingStep,
    stepError,
    generateContentError,
    reloadStep,
    generateContent,
  } = useExperience();

  if (isLoadingStep) {
    return <Loading contain label={translate('pending.step')} />;
  }

  if (stepError) {
    return (
      <div className={classes.failed}>
        <Text
          type='body-2'
          role='alert'
          content={translate('experience.step.failed')}
        />
        <Text
          type='caption'
          color='text-60'
          content={translateError(stepError)}
        />
        <Button
          variant='secondary'
          label={translate('experience.step.retry')}
          onClick={reloadStep}
        />
      </div>
    );
  }

  if (!currentStep) {
    return null;
  }

  const sections = currentStep.sections ?? [];
  const failureMessage = generateContentError
    ? translateError(generateContentError)
    : undefined;

  return (
    <div className={classes['experience-step']}>
      <ExperienceHeading
        title={currentStep.title}
        description={currentStep.description}
        level='h2'
      />
      {failureMessage ? <GenerationFailed onRetry={generateContent} /> : null}
      {sections.map((section, index) => (
        <ExperienceSection
          key={section.id}
          section={section}
          failureMessage={failureMessage}
          isLast={index === sections.length - 1}
        />
      ))}
    </div>
  );
};
